import { Linking } from 'react-native'
import { isHealthConnectAvailable } from 'terra-react'
import { ActiveMinutes } from '@dialogue/services'
import { TrackerName } from '@dialogue/services/dist/active-minutes/model'

export const HEALTH_CONNECT_PLAYSTORE_URL =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.healthdata'
/**
 * This functions is used to redirect the user to play store, it uses Linking API to open the URL.
 * @returns {Promise<void>} - A promise that resolves when the URL is opened.
 */
export const gotoHealthConnectPlayStore = async () => {
  if (await Linking.canOpenURL(HEALTH_CONNECT_PLAYSTORE_URL)) {
    Linking.openURL(HEALTH_CONNECT_PLAYSTORE_URL)
  }
}

/**
 * This function checks if the user can create a new connection with the given provider.
 * It specifically checks for the Health Connect provider and ensures that the app is installed otherwise it redirects the user to the Play Store.
 * @param {TrackerName} provider - The name of the provider to check.
 * @returns {Promise<boolean>} - Returns true if the user can create a new connection, false otherwise.
 */
export const canCreateNewConnection = async (provider: TrackerName) => {
  if (provider === ActiveMinutes.Types.TrackerName.HealthConnect) {
    const result = await isHealthConnectAvailable()

    if (!result) {
      await gotoHealthConnectPlayStore()
      return false
    }
  }

  // All other cases: proceed with connection
  return true
}
